import { useState } from 'react';
import api from '../services/api';

export interface PublicacaoHistorico {
    id: string;
    status: 'pendente' | 'sucesso' | 'erro';
    tentativas: number;
    respostaPortal?: string;
    erroMensagem?: string;
    createdAt: string;
}

export function usePortalPublicacao() {
    const [isPublishing, setIsPublishing] = useState(false);
    const [historico, setHistorico] = useState<PublicacaoHistorico[]>([]);

    const publicarFatura = async (faturaId: string): Promise<{ sucesso: boolean; mensagem: string }> => {
        setIsPublishing(true);
        try {
            const response = await api.post(`/portal/faturas/${faturaId}/publicar`);
            return {
                sucesso: true,
                mensagem: response.data.message || 'Fatura publicada com sucesso no portal',
            };
        } catch (error: any) {
            console.error('Erro ao publicar fatura:', error);
            return {
                sucesso: false,
                mensagem: error.response?.data?.error || 'Erro ao publicar fatura no portal',
            };
        } finally {
            setIsPublishing(false);
        }
    };

    const publicarProposta = async (propostaId: string): Promise<{ sucesso: boolean; mensagem: string }> => {
        setIsPublishing(true);
        try {
            const response = await api.post(`/portal/propostas/${propostaId}/publicar`);
            return {
                sucesso: true,
                mensagem: response.data.message || 'Proposta publicada com sucesso no portal',
            };
        } catch (error: any) {
            console.error('Erro ao publicar proposta:', error);
            return {
                sucesso: false,
                mensagem: error.response?.data?.error || 'Erro ao publicar proposta no portal',
            };
        } finally {
            setIsPublishing(false);
        }
    };

    const buscarHistorico = async (tipo: 'fatura' | 'proposta', documentoId: string) => {
        try {
            const response = await api.get(`/portal/${tipo}/${documentoId}/historico`);
            setHistorico(response.data);
        } catch (error) {
            console.error('Erro ao buscar histórico:', error);
        }
    };

    const retentarPublicacao = async (publicacaoId: string): Promise<{ sucesso: boolean; mensagem: string }> => {
        setIsPublishing(true);
        try {
            const response = await api.post(`/portal/publicacoes/${publicacaoId}/retentar`);
            return {
                sucesso: true,
                mensagem: response.data.message || 'Publicação retentada com sucesso',
            };
        } catch (error: any) {
            console.error('Erro ao retentar publicação:', error);
            return {
                sucesso: false,
                mensagem: error.response?.data?.error || 'Erro ao retentar publicação',
            };
        } finally {
            setIsPublishing(false);
        }
    };

    return {
        isPublishing,
        historico,
        publicarFatura,
        publicarProposta,
        buscarHistorico,
        retentarPublicacao,
    };
}
